
import { PropType, defineComponent } from '@nuxtjs/composition-api'
import { AatriumProduct } from '~/modules/catalog/types'
import { useProductAvailability } from '~/modules/catalog/aatrium/product/composables/useProductAvailability'

export default defineComponent({
  name: 'ProductAvailability',
  props: {
    product: {
      type: [Object, null] as PropType<AatriumProduct>,
      default: null
    }
  },
  setup: props => useProductAvailability(props.product)
})
